<template>
  <div class="uploadproject">
    <headerBar title="溯源项目上传"></headerBar>
    <div class="box710 box">
      <!--第一页-->
      <div v-show="page_num == 1">
        <input type="file" id="imgupload" @change="uploadImg($event)" style="display:none" />

        <div>
          <div @click="(is_video = 0), upLoadImgBtn()">
            <div v-show="!goods_mainshow_64" class="default"><img class="default-img" src="../../static/images/canmera.png" alt="" /></div>
            <div v-show="goods_mainshow_64">
              <div v-show="goods_mainshow_64.indexOf('upload/') == -1"><img class="default" :src="goods_mainshow_64" alt="" /></div>
              <div v-show="goods_mainshow_64.indexOf('upload/') > -1"><img class="default" :src="'https://yuan.znstny.cn/' + goods_mainshow_64" alt="" /></div>
            </div>

            <p class="tips">点击上传图片</p>
            <p style="font-size: 0.22rem;text-align: center;color: #999999;">支持jpg、gif、png格式，建议使用尺寸800x800像素以上、大小不超过4M的正方形图片</p>
          </div>
          <div style="margin-top: 0.2rem;" @click="(is_video = 1), upLoadImgBtn()">
            <div v-show="!goods_video_64" class="default"><img class="default-img" src="../../static/images/canmera.png" alt="" /></div>
            <div v-show="goods_video_64">
              <div v-show="goods_video_64.indexOf('upload/') == -1"><video style="width: 100%;height: 3rem;" :src="goods_video_64" controls></video></div>
              <div v-show="goods_video_64.indexOf('upload/') > -1">
                <video style="width: 100%;height: 3rem;" :src="'https://yuan.znstny.cn/' + goods_video_64" controls></video>
              </div>
            </div>
            <p class="tips">点击上传视频</p>
            <p style="font-size: 0.22rem;text-align: center;color: #999999;">支持mp4、flv格式，大小不超过10M的正方形视频</p>
          </div>
        </div>

        <div class="item">
          <span style="color: red;">*</span>
          产品名称:
          <input type="text" placeholder="请输入内容" v-model="goods_name" />
        </div>
        <div class="item">
          <span style="color: white;">*</span>
          品种名称:
          <input type="text" placeholder="请输入内容" v-model="brand_name" />
        </div>
        <div class="item">
          <span style="color: red;">*</span>
          规格等级:
          <input type="text" placeholder="请输入内容" v-model="norms" />
        </div>
        <div class="item">
          <span style="color: red;">*</span>
          上市时间:
          <input type="text" placeholder="请输入内容(例2020-01-01)" v-model="season_time" />
        </div>
        <div class="item">
          <span style="color: red;">*</span>
          生产规模:
          <input type="text" placeholder="请输入内容" v-model="produce_num" />
        </div>
        <div class="item">
          <span style="color: red;">*</span>
          上市总量:
          <input type="text" placeholder="请输入内容" v-model="season_num" />
        </div>
        <div class="item">
          <span style="color: red;">*</span>
          <span v-if="sort_id == 1">土壤环境</span>
          <span v-if="sort_id == 2">生长环境</span>
          <span v-if="sort_id == 3">水产环境</span>
          <span v-if="sort_id == 4">生产环境</span>
          :
          <input type="text" placeholder="请输入内容" v-model="environment" />
        </div>
        <div class="item">
          <span style="color: red;">*</span>
          <span v-if="sort_id == 1">肥料来源</span>
          <span v-if="sort_id == 2">饲料来源</span>
          <span v-if="sort_id == 3">饲料来源</span>
          <span v-if="sort_id == 4">原料来源</span>
          :
          <input type="text" placeholder="请输入内容" v-model="material" />
        </div>
        <div class="item">
          <span style="color: red;">*</span>
          <span v-if="sort_id == 1">用药来源</span>
          <span v-if="sort_id == 2">用药来源</span>
          <span v-if="sort_id == 3">水质等级</span>
          <span v-if="sort_id == 4">卫生等级</span>
          :
          <input type="text" placeholder="请输入内容" v-model="health" />
        </div>
        <div class="item">
          <span style="color: red;">*</span>
          <span v-if="sort_id == 1">生长环境</span>
          <span v-if="sort_id == 2">饲宿环境</span>
          <span v-if="sort_id == 3">水质含量</span>
          <span v-if="sort_id == 4">营养含量</span>
          :
          <input type="text" placeholder="请输入内容" v-model="nutrition" />
        </div>
        <!-- <div class="item" style="color: red;">商品审核成功后，请谨慎修改，否则会影响溯源信息展示</div> -->
      </div>
      <!--第二页-->
      <div v-show="page_num == 2">
        <div class="item1">
          生长过程:
          <div class="img-list" v-for="(item, index) in grow_progress" :key="index">
            <input type="text" placeholder="请填写描述" v-model="item.step_describe" />
            <input type="text" placeholder="请填写时间,例如2020-01-01" v-model="item.grow_date" />
            <div v-if="!item.growstep_64" class="up-load" @click="upLoadImgBtn(index)">
              <div class="default1"><img class="default-img1" src="../../static/images/canmera.png" alt="" /></div>
            </div>
            <div v-if="item.growstep_64" class="up-load" @click="upLoadImgBtn(index)">
              <img v-if="item.growstep_64.indexOf('upload/') > -1" style="width: 1.2rem;height: 1.2rem;" :src="'https://yuan.znstny.cn/' + item.growstep_64" alt="" />
              <img v-if="item.growstep_64.indexOf('upload/') == -1" style="width: 1.2rem;height: 1.2rem;" :src="item.growstep_64" alt="" />
            </div>
            <span class="tijiao" @click="postGrowData(index)" v-show="item.is_tijiao == 0">提交</span>
            <span class="tijiao" v-show="item.is_tijiao == 1">已提交</span>
            <img @click="deleteList(index)" class="delete" src="../../static/images/close_02.png" alt="" />
          </div>
          <p style="color: red;margin-top: 10px;font-size: 0.24rem;">注：编辑完毕后，请点击提交，已提交的信息不可删除(图片支持jpg、gif、png格式，大小不超过4M的正方形图片)</p>
        </div>
      </div>
      <!--第三页-->
      <div v-show="page_num == 3">
        <div class="item">
          <span style="color: red;">*</span>
          生产负责人:
          <input type="text" placeholder="请输入内容" v-model="product_header" />
        </div>
        <div class="item">
          <span style="color: red;">*</span>
          物流负责人:
          <input type="text" placeholder="请输入内容" v-model="shipping_header" />
        </div>
        <div class="item">
          <span style="color: red;">*</span>
          品质等级:
          <input type="text" placeholder="请输入内容" v-model="quality" />
        </div>
        <div class="item">
          <span style="color: white;">*</span>
          生长坐标:
          <input type="text" placeholder="请输入生长地址(经纬度)" v-model="coordinate" />
        </div>
        <div class="item">
          <span style="color: red;">*</span>
          详细地址:
          <input type="text" placeholder="请输入详细地址" v-model="address" />
        </div>
        <div class="item" style="align-items: flex-start;flex-direction: column;">
          <p>
            <span style="color: red;">*</span>
            产品介绍:
          </p>

          <textarea style="width: 100%;margin-top: 0.1rem;" type="text" placeholder="请输入内容" v-model="product_introduce"></textarea>
        </div>
        <div class="item" style="align-items: flex-start;flex-direction: column;">
          <p>
            <span style="color: red;">*</span>
            基地介绍:
          </p>
          <textarea style="width: 100%;margin-top: 0.1rem;" type="text" placeholder="请输入内容" v-model="base_introduce"></textarea>
        </div>
        <div class="item">
          商城商品ID:
          <input type="number" placeholder="请输入内容" v-model="href" />
        </div>
      </div>
    </div>

    <div class="kuang" style="margin-bottom: 0.5rem;" @click="addList" v-show="page_num == 2"><p>新增</p></div>

    <div class="save" v-show="page_num != 2" @click="doSave()"><p>保存</p></div>

    <div class="step">
      <div class="kuang" style="width: 3rem;margin-top: 0.5rem;" @click="page_num -= 1" v-show="page_num == 2 || page_num == 3"><p>上一步</p></div>
      <div class="kuang" style="width: 3rem;margin-top: 0.5rem;" @click="postData()" v-show="page_num == 1 || page_num == 2">
        <div class="bgmask"></div>
        <p>下一步</p>
      </div>
    </div>
   
    <div class="kuang" v-show="page_num == 3" @click="stepThree">
      <div class="bgmask"></div>
      <p>确认提交</p>
    </div>
     <div v-show="page_num == 3" style="margin:0 auto; width:90%;color:red;padding-bottom:.3rem">商品溯源信息审核通过后，不能再修改，请确认信息准确无误后再提交！</div>
  </div>
</template>

<script>
import { Toast, MessageBox } from 'mint-ui';
export default {
  data() {
    return {
      is_video: 0, //上传的格式 1视频
      url_64: '',
      goods_id: '',
      page_num: 1,
      goods_mainshow: '',
      goods_video: '',
      goods_mainshow_64: '', //图片 视频
      goods_video_64: '',
      goods_name: '', //产品名称
      brand_name: '', //品牌名称
      norms: '', //规格等级
      season_time: '', //上市时间
      season_num: '', //上市总量
      produce_num: '', //生辰规模
      sort_id: '', //产品所属种类
      environment: '', //生产环境  通用。不同类型不一定叫这个名字。但是是这个字段
      material: '', //材料  通用。不同类型不一定叫这个名字。但是是这个字段
      health: '', //卫生   通用。不同类型不一定叫这个名字。但是是这个字段
      nutrition: '', //营养  通用。不同类型不一定叫这个名字。但是是这个字段
      grow_progress: [
        {
          id: '',
          goods_id: '',
          step_describe: '', //描述
          grow_date: '', //时间
          growstep: '', //图片
          growstep_64: '',
          is_tijiao: 0 //是否提交
        }
      ],
      growindex: 0, //生长过程上传图片索引
      product_header: '', //产品负责人
      shipping_header: '', //物流负责人
      quality: '', //品质等级
      coordinate: '', //坐标
      address: '', //详细地址
      product_introduce: '', //产品介绍
      base_introduce: '', //基地介绍
      href: '' //产品链接
    };
  },
  created() {
    //判断登陆状态,
    if (!window.localStorage.getItem('is_check_login') || window.localStorage.getItem('is_check_login') == 0) {
      //登陆失败
      this.$router.push('/login');
    } else {
      this.sort_id = this.$route.query.typeid;
      this.goods_id = this.$route.query.goods_id || '';

      //grow_progress初始值没有带上goods_id
      this.grow_progress[0].goods_id = this.goods_id;

      this.getGoodsInfo();
    }
  },
  methods: {
    getGoodsInfo() {
      this.$request.post('/front/Goods/ginfo', { goods_id: this.goods_id }, res => {
        console.log(res);
        if (res.status == 1) {
          this.goods_name = res.result.goods_name;
          this.goods_mainshow_64 = res.result.goods_mainshow || '';
          this.goods_mainshow = res.result.goods_mainshow;
          this.goods_video = res.result.goods_video;
          this.goods_video_64 = res.result.goods_video || '';
          this.norms = res.result.norms;
          this.season_time = res.result.season_time;
          this.season_num = res.result.season_num;
          this.produce_num = res.result.produce_num;
          this.brand_name = res.result.brand_name;
          this.produce_num = res.result.produce_num;
          this.environment = res.result.environment;
          this.material = res.result.material;
          this.health = res.result.health;
          this.nutrition = res.result.nutrition;
          this.product_header = res.result.product_header;
          this.shipping_header = res.result.shipping_header;
          this.quality = res.result.quality;
          this.coordinate = res.result.coordinate;
          this.address = res.result.address;
          this.product_introduce = res.result.product_introduce;
          this.base_introduce = res.result.base_introduce;
          this.href = res.result.href || '';

          let arraylist = res.result.grow;
          arraylist.forEach((item, index) => {
            let items = {
              id: item.id, //记录的自增id 用于修改
              goods_id: this.goods_id,
              step_describe: item.step_describe, //描述
              grow_date: item.grow_date, //时间
              growstep: item.photo, //图片
              growstep_64: item.photo,
              is_tijiao: 0
            };
            this.grow_progress[index] = items;
          });
        }
      });
    },
    stepThree() {
      if (!this.product_header) {
        Toast('带*号的必须填写');
        return false;
      }
      if (!this.shipping_header) {
        Toast('带*号的必须填写');
        return false;
      }
      if (!this.quality) {
        Toast('带*号的必须填写');
        return false;
      }
      if (!this.address) {
        Toast('带*号的必须填写');
        return false;
      }
      if (!this.product_introduce) {
        Toast('带*号的必须填写');
        return false;
      }
      if (!this.base_introduce) {
        Toast('带*号的必须填写');
        return false;
      }

      this.saveThree(1)
    },
    deleteList(index) {
      //生长过程删除
      if (this.grow_progress[index].is_tijiao == 0) {
        this.grow_progress.splice(index, 1);
      } else {
        Toast('已经提交的资料，已上传服务器，删除无效');
      }
    },
    addList() {
      //生长过程新增
      this.grow_progress.push({
        id: '', //记录的自增id 用于修改
        goods_id: this.goods_id,
        step_describe: '', //描述
        grow_date: '', //时间
        growstep: '', //图片
        growstep_64: '',
        is_tijiao: 0
      });
    },
    upLoadImgBtn(index) {
      this.growindex = index || 0;
      document.getElementById('imgupload').click();
    },
    uploadImg(e) {
      let file = e.target.files[0];
      let type = file.type.split('/')[0];
      if (type == 'image' || type == 'video') {
        //图片转成base64
        let reader = new FileReader();
        reader.readAsDataURL(file);
        //上传
        reader.onloadend = () => {
          let dataUrl = reader.result;
          if (this.page_num == 1) {
            if (this.is_video == 1) {
              this.goods_video = file;
              this.goods_video_64 = dataUrl;
            } else {
              this.goods_mainshow_64 = dataUrl;
              this.goods_mainshow = file;
            }
          } else if (this.page_num == 2) {
            //第二页
            console.log(this.growindex);
            let array = [...this.grow_progress];
            array[this.growindex].growstep = file;
            array[this.growindex].growstep_64 = dataUrl;
            this.grow_progress = [...array];
          }
          e.target.value = '';
        };
      } else {
        Toast('请上传图片或者视频');
      }
    },
    postData() {
      if (this.page_num == 1) {
        this.stepOne();
      } else if (this.page_num == 2) {
        this.page_num += 1;
      }
    },
    postGrowData(index) {
      let item = this.grow_progress[index];
      let data = new FormData();
      data.append('id', item.id || '');
      data.append('goods_id', item.goods_id);
      data.append('step_describe', item.step_describe);
      data.append('grow_date', item.grow_date);
      data.append('growstep', item.growstep);

      this.$request.post('/front/Appgood/goodtwo', data, res => {
        if (res.status == 1) {
          item.is_tijiao = 1;
        }
        Toast(res.msg);
      });
    },
    stepOne() {
      if (!this.goods_mainshow) {
        Toast('请上传图片');
        return false;
      }
      if (!this.goods_name) {
        Toast('带*号的必须填写');
        return false;
      }
      if (!this.norms) {
        Toast('带*号的必须填写');
        return false;
      }
      if (!this.season_time) {
        Toast('带*号的必须填写');
        return false;
      }else{
        if(this.season_time != ''){
          var reg=/^[1-9]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])$/;
          if(!reg.test(this.season_time)){
            Toast('日期格式不正确，正确格式为：2014-01-01')
            return false;
          }
        }
      }
      if (!this.season_num) {
        Toast('带*号的必须填写');
        return false;
      }
      if (!this.produce_num) {
        Toast('带*号的必须填写');
        return false;
      }
      if (!this.environment) {
        Toast('带*号的必须填写');
        return false;
      }
      if (!this.material) {
        Toast('带*号的必须填写');
        return false;
      }
      if (!this.health) {
        Toast('带*号的必须填写');
        return false;
      }
      if (!this.nutrition) {
        Toast('带*号的必须填写');
        return false;
      }
      this.saveOne(1);
    },
    doSave(){
      var that=this;
      if(that.page_num==1){
        console.log('page_num=',that.page_num)
        that.saveOne(0)
      }
      if(that.page_num==3){
        console.log('page_num=',that.page_num)
        that.saveThree(0)
      }
      
    },
    saveOne(isSubmit=1){
      let data = new FormData();
      data.append('sort_id', this.sort_id);
      data.append('id', this.goods_id || ''); //修改的时候需要传产品id
      data.append('goods_mainshow', this.goods_mainshow);
      data.append('goods_video', this.goods_video);
      data.append('goods_name', this.goods_name);
      data.append('brand_name', this.brand_name);
      data.append('norms', this.norms);
      data.append('season_time', this.season_time);
      data.append('season_num', this.season_num);
      data.append('produce_num', this.produce_num);
      data.append('environment', this.environment);
      data.append('material', this.material);
      data.append('health', this.health);
      data.append('nutrition', this.nutrition);
      console.log('data', data);
      this.$request.post('/front/Appgood/goodone', data, res => {
        if (res.status == 1) {
          if(isSubmit==1){
            this.page_num += 1;
            this.goods_id = res.result;
            //新建第一步会返还goods_id， 第二步初始grow_progress[0]参数
            this.grow_progress[0].goods_id = this.goods_id;
          }else{
            Toast('保存成功');
          }
        }
      });
    },
    saveThree(isSubmit=1){
      let data = new FormData();
      data.append('goods_id', this.goods_id);
      data.append('product_header', this.product_header);
      data.append('shipping_header', this.shipping_header);
      data.append('quality', this.quality);
      data.append('coordinate', this.coordinate);
      data.append('address', this.address);
      data.append('product_introduce', this.product_introduce);
      data.append('base_introduce', this.base_introduce);
      data.append('href', this.href);
      if(isSubmit==0){
        data.append('type', 'save');
      }
      this.$request.post('/front/Appgood/goodthree', data, res => {
        if (res.status == 1) {
          if(isSubmit==1){
            setTimeout(() => {
              this.$router.push('/projectList');
            }, 1200);
          }else{
            Toast('保存成功');
          }
        }
      });
    }

  }
}
</script>

<style lang="scss" scoped>
.uploadproject {
  padding-top: 0.8rem;
}
.box {
  .default {
    width: 2.2rem;
    height: 2.2rem;
    margin: 0 auto;
    border: 1px solid #cccccc;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    .default-img {
      width: 1rem;
      height: 0.8rem;
    }
  }
  .tips {
    margin-top: 0.2rem;
    width: 100%;
    text-align: center;
  }
  .item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0.3rem 0;
    padding-right: 0.3rem;
    input,
    textarea {
      display: block;
      height: 0.7rem;
      line-height: 0.7rem;
      padding-left: 10px;
      border: 1px solid #cccccc;
      border-radius: 5px;
      width: 4.5rem;
    }
    textarea {
      height: 2rem;
      padding: 0.2rem;
      line-height: initial;
      font-size: 0.3rem;
    }
  }
  .item1 {
    padding-right: 0.3rem;
    .img-list {
      width: 100%;
      padding: 0.2rem;
      border-bottom: 1px solid #cccccc;
      position: relative;
      input {
        width: 5rem;
        height: 0.6rem;
        border: 1px solid #cccccc;
        border-radius: 5px;
        margin: 0.1rem 0;
        padding-left: 0.2rem;
      }

      .delete {
        width: 0.5rem;
        height: 0.5rem;
        position: absolute;
        top: 0.2rem;
        right: 0.2rem;
      }
      .up-load {
        width: 1.4rem;
        height: 1.4rem;
        .default1 {
          width: 1.4rem;
          height: 1.4rem;
          display: flex;
          align-items: center;
          justify-content: center;
          border: 1px solid #cccccc;
          border-radius: 5px;
          position: relative;
          .default-img1 {
            width: 0.6rem;
            height: 0.5rem;
          }
        }
      }
    }
  }
}
.tijiao {
  position: absolute;
  color: #299e72;
  bottom: 0.2rem;
  right: 0.2rem;
}
.step {
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.kuang {
  // margin-top: 1rem;
  margin:0.3rem auto 0.2rem;
  border-color: #299e72;
  .bgmask {
    background: #299e72;
  }
  p {
    color: #299e72;
    font-size: 0.38rem;
  }
}
.save{
  margin: 0rem auto; text-align: center; line-height: .8rem;
  width: 3rem; border-radius: 5px;
   background: #750505;
   color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/pages/uploadProject.vue